<template>
  <DeleteConfirm
      itemKey="TicketItemTask"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import TicketItemTasks from '@/services/ticket-item-tasks'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return TicketItemTasks
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť úlohu z ' + this.$moment(Item.createdAt).format('DD.MM.YYYY HH:mm') + ' od ' + Item.Creator.name
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť úlohu z ' + this.$moment(Item.createdAt).format('DD.MM.YYYY HH:mm') + ' od ' + Item.Creator.name + '?'
      },
      deleteData() {
        return TicketItemTasks
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
